
export class RapportsRembourse {
    id_rap_remb:any;
    vague  :any;
    date_deb_rap_remb :any;
    date_fin_rap_remb :any;
    nombre :any;
    montant :any;
    fichier:any;
    etat :any
    responsable:any

    constructor( id_rap_remb:any){
      
    }
}
